export default "__VITE_ASSET__ATKd6$il__"